import { motion } from "framer-motion";
import { marketing, useMarketingLocale } from "@/i18n/marketing";

export const HowItWorks = () => {
  const locale = useMarketingLocale();
  const t = marketing.home[locale].howItWorks;

  const steps = [
    { number: 1, title: t.step1Title, description: t.step1Body },
    { number: 2, title: t.step2Title, description: t.step2Body },
    { number: 3, title: t.step3Title, description: t.step3Body },
  ];

  return (
    <motion.div
      className="py-16 bg-muted/30"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5, delay: 0.3 }}
    >
      <div className="max-container">
        <div className="text-center mb-12">
          <h2 className="heading-2 mb-3 text-foreground">{t.heading}</h2>
          <p className="text-xl text-white dark:text-gray-200 max-w-2xl mx-auto">
            {t.subhead}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {steps.map((step) => (
            <div
              key={step.number}
              className="bg-white dark:bg-card border rounded-xl p-8 shadow-sm"
            >
              <div className="w-12 h-12 rounded-full bg-primary text-primary-foreground flex items-center justify-center font-bold text-xl mb-4">
                {step.number}
              </div>
              <h3 className="text-xl font-bold mb-2 text-foreground">
                {step.title}
              </h3>
              <p className="text-muted-foreground">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </motion.div>
  );
};
